/* ===== AROMAZUR : avis clients publiés (visibles par TOUS les visiteurs) =====
   Les avis sont stockés ici, dans le thème. Ils s'affichent pour tout le monde,
   contrairement aux avis en localStorage qui ne sont visibles que par leur auteur.
   Pour ajouter un avis : compléter le tableau AZ_REVIEWS ci-dessous.
   Format : { p:"handle-produit", a:"Prénom", n:5, d:"12/03/2026", t:"texte", v:true }
   ( p = produit · a = auteur · n = note /5 · d = date · t = texte · v = achat vérifié ) */

/* Les avis ne se saisissent PLUS ici : ils vivent dans
   snippets/az-avis-data.liquid, qui alimente window.AZ_REVIEWS avant le
   chargement de ce fichier — et, du meme coup, les donnees structurees
   envoyees a Google. Cette ligne ne sert que de filet si le snippet
   n'a pas ete rendu. */
window.AZ_REVIEWS = window.AZ_REVIEWS || [];

(function(){
  function lang(){ try{return localStorage.getItem('az_lang')||'fr';}catch(e){return 'fr';} }

  function build(){
    /* REVIEWS n'est defini que dans index.liquid : ce garde-fou empechait les cinq
       temoignages professionnels de s'afficher sur les fiches produit, c'est-a-dire
       la ou un acheteur va justement chercher un avis avant de payer 475 euros. */
    if(typeof REVIEWS==='undefined'){ window.REVIEWS={}; }
    if(typeof window.REVIEWS==='undefined') window.REVIEWS={};
    var REVIEWS=window.REVIEWS;
    var en=(lang()==='en');
    /* index par produit, en conservant les avis locaux éventuels */
    var byHandle={};
    (window.AZ_REVIEWS||[]).forEach(function(r){
      if(!r||!r.p) return;
      (byHandle[r.p]=byHandle[r.p]||[]).push({author:r.a||'Client', rating:+r.n||5, text:r.t||'', date:r.d||'', verified:r.v!==false});
    });
    /* témoignages professionnels : rattachés à leur fiche produit,
       affichés avec le type d'établissement (jamais le badge « achat vérifié ») */
    (window.AZ_PRO_TESTIMONIALS||[]).forEach(function(r){
      if(!r||!r.h) return;
      (byHandle[r.h]=byHandle[r.h]||[]).push({
        author:(r.a||'')+' — '+(en?(r.te||''):(r.t||'')),
        rating:+r.n||5,
        text:(en?r.xe:r.x)||'',
        date:(en?r.de:r.d)||'',
        verified:false,
        pro:true
      });
    });
    Object.keys(byHandle).forEach(function(h){
      var local=(REVIEWS[h]||[]).filter(function(x){return !x._pub;});
      byHandle[h].forEach(function(x){x._pub=true;});
      REVIEWS[h]=byHandle[h].concat(local);
    });
    window.AZ_REVIEW_INDEX=byHandle;
    decorateCards();
  }

  /* étoiles + nombre d'avis sur les vignettes produit */
  function decorateCards(){
    var idx=window.AZ_REVIEW_INDEX||{};
    if(!document.getElementById('azRevStyle')){
      var st=document.createElement('style'); st.id='azRevStyle';
      st.textContent='.az-card-rev{display:flex;align-items:center;gap:6px;margin-top:6px;font-size:12px;color:#8a8272;font-family:Georgia,serif}'+
        '.az-card-rev .s{color:#D4A63C;letter-spacing:1px}';
      document.head.appendChild(st);
    }
    document.querySelectorAll('.card').forEach(function(card){
      if(card.querySelector('.az-card-rev')) return;
      var oc=card.getAttribute('onclick')||'';
      var lien=card.querySelector('a[href*="/products/"]');
      var m=oc.match(/openProduct\('([^']+)'\)/)
          || oc.match(/\/products\/([^'"?#]+)/)
          || (lien?(lien.getAttribute('href')||'').match(/\/products\/([^'"?#]+)/):null)
          || (card.getAttribute('href')||'').match(/\/products\/([^'"?#]+)/); /* carte-lien (snippet product-card) */
      if(!m) return;
      var hh=m[1];
      /* Notes + univers (09/09/2026) : les cartes rendues par Shopify (collections,
         recherche, best-sellers) recoivent les deux lignes deja presentes sur les
         cartes statiques de l'accueil, depuis la base az-db.js. */
      try{
        var DB=window.AZ_DB||{}, pr=DB[hh]||DB['az-'+hh];
        if(pr&&pr.type==='huile'&&(pr.cardNotes||pr.univers)&&!card.querySelector('.card-notes')){
          var hostN=card.querySelector('.card-body')||card, h3=hostN.querySelector('h3');
          var frag=document.createDocumentFragment();
          if(pr.cardNotes){ var dn=document.createElement('div'); dn.className='card-notes'; dn.textContent=pr.cardNotes; frag.appendChild(dn); }
          if(pr.inspire){ var di=document.createElement('div'); di.className='card-univ card-insp'; di.innerHTML='Inspiré par : <b></b>'; di.querySelector('b').textContent=pr.inspire; frag.appendChild(di); }
          else if(pr.univers){ var du=document.createElement('div'); du.className='card-univ'; du.textContent=pr.univers; frag.appendChild(du); }
          if(h3&&h3.parentNode===hostN) hostN.insertBefore(frag,h3.nextSibling); else hostN.insertBefore(frag,hostN.firstChild);
        }
      }catch(e){}
      var list=idx[hh]||idx['az-'+hh]||idx[hh.replace(/^az-/,'')]; if(!list||!list.length) return;
      var avg=list.reduce(function(s,r){return s+r.rating;},0)/list.length;
      var full=Math.round(avg);
      var d=document.createElement('div'); d.className='az-card-rev';
      d.innerHTML='<span class="s">'+('★★★★★'.slice(0,full)+'☆☆☆☆☆'.slice(0,5-full))+'</span><span>'+avg.toFixed(1)+' · '+list.length+' avis</span>';
      var host=card.querySelector('.card-body')||card;
      var price=host.querySelector('.price');
      if(price&&price.parentNode) price.parentNode.insertBefore(d, price);
      else host.appendChild(d);
    });
  }

  function boot(){
    build();
    /* re-décorer après les filtres / rendus dynamiques */
    /* Un MutationObserver sur tout le document relancait une boucle sur 39 cartes
       a chaque rendu du tiroir, chaque filtre, chaque revelation au defilement.
       Il se deconnecte desormais des qu'il a decore les cartes, et au plus tard
       apres huit secondes. */
    var mo=new MutationObserver(function(){
      decorateCards();
      if(document.querySelectorAll('.card').length) mo.disconnect();
    });
    if(document.body) mo.observe(document.body,{childList:true,subtree:true});
    setTimeout(function(){ try{mo.disconnect();}catch(e){} },8000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else setTimeout(boot,0);
})();
